import { useLayoutEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import ApiUrl from 'services/shared/ApiUrl';
const Header = () => {
    const location = useLocation();
    const [isSticky, setIsSticky] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 100) { 
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
    };

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    return (
        <div className={isSticky ? "stricky-fixed" : ""}>
            <div className="page-wrapper ">
                <header className="main-header">
                    {/* <div class="offer">
                            <p>Join us at the 1WN Conference 2025 &nbsp; –<Link className="register--" to="/membership-registration"> Register now!</Link></p>
                    </div> */}
               
                    <nav className="main-menu">
                        <div className="main-menu__wrapper">
                            <div className="container">
                                <div className="main-menu__wrapper-inner">
                                    <div className="main-menu__left">
                                        <div className="main-menu__logo">
                                            <Link to='/'><img src="images/resources/1wn-logo.png" alt=""></img>
                                            </Link>
                                        </div>
                                        <div className="main-menu__main-menu-box">
                                            <a href="#" className="mobile-nav__toggler"><i className="fa fa-bars"></i></a>
                                            <ul className="main-menu__list">
                                                <li className={location.pathname === "/" ? "active" : ""}>
                                                    <NavLink exact to="/" activeClassName="active-link">Home</NavLink>
                                                </li>
                                                <li className={location.pathname === "/about-us" ? "active dropdown" : "dropdown"}>
                                                    <NavLink exact to="/about-us" activeClassName="active-link">About us</NavLink>
                                                    <ul>
                                                        <li><Link to='/board-of-advisor'>Board of Advisors</Link></li>
                                                        <li><Link to="accrediations">1WN Associations & Accreditations</Link></li>
                                                    </ul>
                                                </li>

                                                <li className={location.pathname === "/membership-center" ? "active dropdown" : "dropdown"}>
                                                    <NavLink exact to="/membership-center" activeClassName="active-link">1WN Membership Center</NavLink>
                                                    <ul>
                                                    <li><Link to="/membership-benifits">Membership Benefits</Link></li>
                                                        <li><Link to="/membership-registration">Membership Registration</Link></li>
                                                        <li><Link to="/verticals">Our Verticals</Link></li>
                                                    </ul>
                                                </li>
                                                <li className={location.pathname === "/upcoming-events" ? "active dropdown" : "dropdown"}>
                                                    <NavLink exact to="/upcoming-events" activeClassName="active-link">1WN Conference</NavLink>
                                                    <ul>
                                                        <li><Link to="/upcoming-events">Upcoming Events</Link></li>
                                                        <li><Link to="/previous-events">Past Events</Link></li>
                                                        <li><Link to="/post-event-gallery">Photo Gallery</Link></li>
                                                    </ul>
                                                </li>

                                                <li className={location.pathname === "/news-and-media" ? "active dropdown" : "dropdown"}>
                                                    <NavLink exact to="/news-and-media" activeClassName="active-link">1WN News & Media</NavLink>
                                                    <ul>
                                                        <li><Link to="/newsletter">Newsletter</Link></li>
                                                    </ul>
                                                </li>
                                            
                                                {/* <li className={location.pathname === "/news-and-media" ? "active" : ""}>
                                                    <NavLink exact to="/news-and-media" activeClassName="active-link">1WN News & Media</NavLink>
                                              
                                                </li> */}


                                                <li className={location.pathname === "/blog" ? "active" : ""}>
                                                    <NavLink exact to="/blog" activeClassName="active-link">Blog</NavLink>
                                              
                                                </li>

                                        
                                          
                                                <li className={location.pathname === "/contact" ? "active" : ""}>
                                                    <NavLink exact to="/contact" activeClassName="active-link">Contact Us</NavLink>
                                                </li>
                                          
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="main-menu__right">
                                        <div className="main-menu__search-nav-sidebar-btn-box">
                                      
                                            <div className="main-menu__nav-sidebar-icon">
                                            </div>
                                            <div className="main-menu__btn-box">
                                                <Link to={"/membership-registration"} className="thm-btn main-menu__btn mr-2">Join Now<span className='omaga'></span></Link>
                                                <Link target='blank' to={ApiUrl.dashboardBaseUrl} className="thm-btn main-menu__btn">Login<span className='omaga btn-omaga'><i class="fa fa-user"></i></span></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>
            </div>
        </div>
    )
}

export default Header




















